import { Box, Chip, Stack, Typography } from "@mui/material";
import StyledButton from "../custom/StyledButton";
import "./OrderCard.css";
import { useContext } from "react";
import { UserContext } from "../../../../../../App";

const css = (status) => {
  switch (status) {
    case "PAID":
      return {
        color: "green",
        backgroundColor: "#e6ffe6",
        fontWeight: "bold",
      };
    case "CREATED":
      return {
        color: "#0868fe",
        backgroundColor: "#e6f2ff",
        fontWeight: "bold",
      };
    case "CANCELLED":
      return {
        color: "#ff0000",
        backgroundColor: "#ffe6e6",
        fontWeight: "bold",
      };
      case "PAYMENT_CANCELLED":
        return {
          color: "#ff0000",
          backgroundColor: "#ffe6e6",
          fontWeight: "bold",
        };
    default:
      return {
        color: "#0868fe",
        backgroundColor: "#e6f2ff",
        fontWeight: "bold",
      };
  }
};
const OrderCard = ({ order, orderDetailsPage }) => {
  const { color } = useContext(UserContext);
  return (
    <Stack className="order-item">
      <Box className="order-item-header">
        <Stack>
          <Typography variant="h7" fontWeight={600}>
            Order #{order?.order_id}
          </Typography>
          <Typography variant="h7" fontSize={14}
          
           color={color === 'light' ? "gray" : "darkgrey"}>
            {order?.date}
          </Typography>
        </Stack>
        <Typography variant="h6" fontWeight={600}>
          {order?.amount}
        </Typography>
      </Box>
      <hr className="divider" />
      <Box className="order-item-body">
        <Stack>
          <Typography variant="h7" fontSize={14} color={color === 'light' ? "gray" : "darkgrey"}>
            Customer Name / Number
          </Typography>
          <Typography variant="h7" fontWeight={600}>
            {order?.customer_number_name}
          </Typography>
        </Stack>
        <Stack alignItems="flex-end">
          <Typography variant="h7" fontSize={14} color={color === 'light' ? "gray" : "darkgrey"}>
            Items
          </Typography>
          <Typography variant="h7" fontWeight={600}>
            {order?.items}
          </Typography>
        </Stack>
      </Box>
      <hr className="divider" />
      <Box className="order-item-actions">
        <Chip sx={css(order?.status)} label={order?.status} />
        <StyledButton size="small" onClick={(event) => orderDetailsPage(order?.order_id, event)}>
          View
        </StyledButton>
      </Box>
    </Stack>
  );
};

export default OrderCard;
